var render = function () {
var _obj, _obj$1, _obj$2, _obj$3;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
    _vm.$style.button,
    _vm.$style[_vm.variant],
    ( _obj = {}, _obj[_vm.$style.inverse] = _vm.inverse, _obj ),
    ( _obj$1 = {}, _obj$1[_vm.$style.iconBefore] = _vm.iconBefore, _obj$1 ),
    ( _obj$2 = {}, _obj$2[_vm.$style.iconAfter] = _vm.iconAfter, _obj$2 ),
    ( _obj$3 = {}, _obj$3[_vm.$style.asLink] = _vm.asLink, _obj$3 )
  ],attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.iconBefore)?_c('icon',{class:_vm.$style.iconLeft,attrs:{"icon":_vm.iconBefore}}):_vm._e(),_vm._t("default"),(_vm.iconAfter)?_c('icon',{class:_vm.$style.iconRight,attrs:{"icon":_vm.iconAfter}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }